// extracted by mini-css-extract-plugin
module.exports = {"achievements":"styles_achievements__Fht_e"};